
<template>
    <div>
        <div class="banner">
            <img class="banner-img" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/pc-banner.png" alt="" srcset="">
        </div>
        <div class="content">
            <img class="content-title" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/pc-icon1.png" alt="" srcset="">

            <img class="content-img" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/pc-img1.png" alt="" srcset="">
            <img class="content-btn" @click="toBuy" style="margin-bottom: 25px;margin-top: 5px;" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/pc-btn.png" alt="" srcset="">

            <img class="content-img" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/pc-img2.png" alt="" srcset="">
            <img class="content-btn" @click="toBuy" style="margin-bottom: 42px;margin-top: 5px;" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/pc-btn.png" alt="" srcset="">
        </div>
         <div class="content content2">
            <img class="content-title" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/pc-icon2.png" alt="" srcset="">
            <img class="content-img" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/pc-img3.png" alt="" srcset="">
            <img class="content-img" style="margin-bottom: 60px;" src="https://cdn.zxzx119.com/zxzx-h5/activity/accompanyBag/pc-img4.png" alt="" srcset="">
         </div>
    </div>
</template>
<script>
export default {
    name:'',
    components: {
    },
    data () {
        return {
        
        }
    },
    created () {
        
    },
    methods: {
        toBuy() {
            window.open('https://www.zxmall119.com/goodscompany/26359?id=14015')
        }

    },
    mounted () {
        
    },
}

</script>


<style lang='scss' scoped>
.banner{
    width: 100%;
    background: #fff;
    .banner-img{
        width: 100%;
        height: 100%;
    }

}
.content{
    text-align: center;
    background-color: #fff;
     padding: 0 170px;
    .content-title{
        width: 210px;
        margin-top: 14px;
        margin-bottom: 20px;
    }
    .content-img{
        width: 100%;
       

    }
    .content-btn{
        width: 125px;
        cursor: pointer;
    }
}
.content2{
    background-color: #F6F6F6;
    padding: 0 180px;
    .content-title{
        width: 115px;
        margin-top: 40px;
        margin-bottom: 25px;

    }
    .content-img{
        width: 100%;
        margin-bottom: 25px;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/activity/accompanyBag/index-pc.vue